export default __webpack_public_path__ + "static/media/Logout.4421ee57.svg";